import {
  SR_API_ACTION_PARTNER_GET,
} from 'api/actionTypes';

export default async function getByManagementCompanyName(
  { state, apiClient },
  { managementCompanyName }
) {
  const statePath = ['partners', 'byManagementCompanyName', managementCompanyName];
  if (state.get(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET,
    queryId: managementCompanyName,
    state: state,
    payload: {
      managementCompanyName: managementCompanyName,
    },
    onSuccess(partnerListingStats) {
      state.set(statePath, partnerListingStats);
    },
  });
}
